import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { formatProductoNombre } from '../utils/productoInventarioHelper';

const HEADERS = [
  'Nombre',
  'Medida',
  'Total',
  'Reservado',
  'Solicitado',
  'Disponible',
  'Última Actualización'
];

export function mapInventariosToRows(inventarios = []) {
  return inventarios.map(item => {
    const nombre = formatProductoNombre(item);
    const medida = item.texto_medida || '-';
    const total = item.total || 0;
    const reservado = item.reservado || 0;
    const solicitado = item.solicitado || 0;
    const disponible = Math.max(0, total - reservado);
    const fecha = item.updated ? new Date(item.updated).toLocaleDateString('es-ES') : '';

    return [
      nombre,
      medida,
      total,
      reservado,
      solicitado,
      disponible,
      fecha
    ];
  });
}

export function generateInventarioFilename(date = new Date()) {
  const iso = new Date(date).toISOString().split('T')[0];
  const compact = iso.replace(/-/g, '');
  return `inventario-${compact}.xlsx`;
}

export function generateInventarioExcel(inventarios = []) {
  if (!inventarios || inventarios.length === 0) {
    throw new Error('No hay inventario para exportar');
  }

  const rows = mapInventariosToRows(inventarios);
  const sheet = XLSX.utils.aoa_to_sheet([HEADERS, ...rows]);

  sheet['!cols'] = [
    { wch: 35 }, // Nombre
    { wch: 15 }, // Medida
    { wch: 12 }, // Total
    { wch: 12 }, // Reservado
    { wch: 12 }, // Solicitado
    { wch: 12 }, // Disponible
    { wch: 18 }  // Última Actualización
  ];

  const headerRange = sheet['!ref'] ? XLSX.utils.decode_range(sheet['!ref']) : null;
  if (headerRange) {
    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      if (!sheet[cellAddress]) continue;

      sheet[cellAddress].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: 'E6E6FA' } },
        alignment: { horizontal: 'center', vertical: 'center' }
      };
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Inventario');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  saveAs(blob, generateInventarioFilename());
}
